import SiteHeader from './header';

export default {
  init: function (selector) {
    const siteHeader = document.querySelector(selector);

    if (siteHeader) {
      const siteHeaderInit = new SiteHeader(siteHeader);
      siteHeaderInit.init();
    }
  }
};
